import useMountEffect from "./useMountEffect";

export function useHideLoadingAnimation() {
  useMountEffect(() => {
    document.getElementById("doit-page-loader-animation")?.remove();
  });
}
